import { render, staticRenderFns } from "./guards.vue?vue&type=template&id=0ab717b6&scoped=true"
import script from "./guards.vue?vue&type=script&lang=js"
export * from "./guards.vue?vue&type=script&lang=js"
import style0 from "./guards.vue?vue&type=style&index=0&id=0ab717b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab717b6",
  null
  
)

export default component.exports